// ** React Imports
import { useCallback, useMemo } from "react";

// ** Redux & Store & Actions
import { useSelector, useDispatch } from "react-redux";
import { toggleFilters } from "store/modules/shared-filters.slice";

// ** Custom Components
import SelectedElement from "components/other/SelectedElement";
import Block from "components/layout/Block";

// ** Hooks
import useSexFilterData from "../hooks/useSexFilterData";
import useLocationFilterData from "../hooks/usePostsLocationFilterData";
import usePeriodFilterData from "../hooks/usePeriodFilterData";

// ** Users Components
import ChangeFiltersButton from "containers/Users/components/ChangeFiltersButton";

// #####################################################

const ResultsDescription = () => {
	const language = useSelector((state) => state.globalCommon.language);

	const dispatch = useDispatch();
	const filtersOpen = useSelector((state) => state.sharedFilters.isOpen);

	const sexFilterData = useSexFilterData();
	const locationFilterData = useLocationFilterData();
	const periodFilterData = usePeriodFilterData();

	// ** Filtry - Lista
	const filtersArray = useMemo(() => {
		const filtersArray = [
			sexFilterData,
			periodFilterData,
			locationFilterData,
			// searchSexFilterData,
		];
		return filtersArray.filter((x) => Boolean(x));
	}, [
		sexFilterData,
		locationFilterData,
		periodFilterData,
		// searchSexFilterData,
		language,
	]);

	const renderSelectedFilters = useCallback(() => {
		return filtersArray.map((filter, index) => (
			<SelectedElement
				key={index}
				data={filter}
				isLastFilter={filtersArray.length === index + 1}
				labelToLowerCase={false}
			/>
		));
	}, [filtersArray]);

	const toggleFiltersFn = useCallback(() => {
		dispatch(toggleFilters());
	}, []);

	// #####################################################

	return (
		<Block flex alignCenter>
			<Block>
				{renderSelectedFilters()}
				<ChangeFiltersButton
					filtersOpen={filtersOpen}
					setFiltersOpen={toggleFiltersFn}
				/>
			</Block>
		</Block>
	);
};

// #####################################################

export default ResultsDescription;

// #####################################################
